// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style the lead details container */
.leadDetails-container {
  margin: 1rem auto;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 100%;
  height: auto;
  padding: 8px;
}

/* Style the lead details heading */
.leadDetailsHeading {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* Style the lead details form */
.leadDetailsCard {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Style the lead details card body */
.leadDetailsCardBody {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Style the lead details card input fields */
.leadDetailsCardInputFields {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}

/* Style the lead details card label */
.leadDetailsCardInputFields label,
.leadDetailsCardSelectables label {
  display: block;
  margin-bottom: 5px;
  font-size: 1.5rem; /* Adjusted font size */
}

/* Style the lead details card input and textarea */
.leadDetailsCardInputFields input,
.leadDetailsCardInputFields textarea,
.leadDetailsCardSelectables select {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 1.5rem; /* Adjusted font size */
}

/* Style for placeholders */
.leadDetailsCardInputFields input::-moz-placeholder, .leadDetailsCardInputFields textarea::-moz-placeholder {
  font-size: 1.5rem; /* Adjusted font size for placeholders */
}
.leadDetailsCardInputFields input::placeholder,
.leadDetailsCardInputFields textarea::placeholder {
  font-size: 1.5rem; /* Adjusted font size for placeholders */
}

/* Style the lead details card selectables */
.leadDetailsCardSelectables {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}

/* Style the lead details card actions */
.leadDetailsActions {
  display: flex;
  justify-content: space-between;
}

/* Style the lead details card buttons */
.leadDetailsActions button {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  font-size: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/LeadDetails.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;;EAEE,cAAc;EACd,kBAAkB;EAClB,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA,mDAAmD;AACnD;;;EAGE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA,2BAA2B;AAC3B;EAEE,iBAAiB,EAAE,wCAAwC;AAC7D;AAHA;;EAEE,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["/* Style the lead details container */\n.leadDetails-container {\n  margin: 1rem auto;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 100%;\n  height: auto;\n  padding: 8px;\n}\n\n/* Style the lead details heading */\n.leadDetailsHeading {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n/* Style the lead details form */\n.leadDetailsCard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* Style the lead details card body */\n.leadDetailsCardBody {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* Style the lead details card input fields */\n.leadDetailsCardInputFields {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n/* Style the lead details card label */\n.leadDetailsCardInputFields label,\n.leadDetailsCardSelectables label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 1.5rem; /* Adjusted font size */\n}\n\n/* Style the lead details card input and textarea */\n.leadDetailsCardInputFields input,\n.leadDetailsCardInputFields textarea,\n.leadDetailsCardSelectables select {\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 1.5rem; /* Adjusted font size */\n}\n\n/* Style for placeholders */\n.leadDetailsCardInputFields input::placeholder,\n.leadDetailsCardInputFields textarea::placeholder {\n  font-size: 1.5rem; /* Adjusted font size for placeholders */\n}\n\n/* Style the lead details card selectables */\n.leadDetailsCardSelectables {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n/* Style the lead details card actions */\n.leadDetailsActions {\n  display: flex;\n  justify-content: space-between;\n}\n\n/* Style the lead details card buttons */\n.leadDetailsActions button {\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
